import type { IWidgetComponentPropsConfig, Widget } from '@framework/engine';
import {
  WidgetComponentContextProvider,
  WidgetRepository,
} from '@framework/engine';
import { WidgetPreviewForm } from '@framework/form';
import { Empty } from 'antd';
import React from 'react';
import { InputContainer } from './InputContainer';

export interface IWidgetConfigProps {
  widget: Widget;
  children?: React.ReactNode;
  componentLayout?: IWidgetComponentPropsConfig;
}

/**
 * Componente che, dato un widget, ne restituisce il componente da mostrare
 * durante la configurazione recuperandolo dal widget repository
 */
export const PreviewComponent = React.memo(
  (props: IWidgetConfigProps) => {
    const { widget, children, componentLayout } = props;
    const widgetComponent = WidgetRepository.find(widget.type);

    if (!widgetComponent) {
      console.warn(`No widget found for type ${widget.type}`, {widget}); // prettier-ignore
      return (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={`Widget "${widget.type}" non riconosciuto. È possibile eliminare il widget e aggiungerne uno nuovo.`}
          style={{
            padding: '12px',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: '12px',
          }}
        />
      );
    }

    return (
      <InputContainer>
        <WidgetComponentContextProvider preview>
          <WidgetPreviewForm nested layout="vertical">
            <widgetComponent.previewComponent
              widget={widget}
              children={children}
              componentLayout={componentLayout}
              preview
            />
          </WidgetPreviewForm>
        </WidgetComponentContextProvider>
      </InputContainer>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.widget === nextProps.widget;
  },
);

PreviewComponent.displayName = 'PreviewComponent';
